import { Avatar } from "@mui/material";
import { stringAvatar } from "pages/utils";

interface UserAvatarProps {
  name: string;
  sizes?: string;
  src?: string;
  onClick?: () => void;
}

const UserAvatar: React.FC<UserAvatarProps> = ({
  name,
  src,
  sizes,
  onClick,
}) => {
  return (
    <Avatar
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...stringAvatar(name || "", { flexBasis: "40px" })}
      onClick={onClick}
      sizes={sizes}
      sx={{ fontSize: "14px" }}
      // generate random placeholder avatar
      src={src || ""}
    />
  );
};

export default UserAvatar;
